import { type MotionValue } from 'motion/react'
import type { ReactNode } from 'react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
  StickyViewHeaderSpacer,
  StickyViewHeaderExtras,
} from '@/components/StickyViewHeader'
import { ViewHeading } from '@/components/ViewHeading'
import { AvatarSelector } from '@/features/iam/users/components/AvatarSelector'
import { type AvatarSubject } from '@/components/Avatar'
import { byDesign } from '@/infra/design'

export interface ProfileHeaderProps {
  viewTitle: string
  scrollOffset: MotionValue<number>
  displayName: string
  avatar: AvatarSubject
  isAvatarUploading: boolean
  onSelectNewAvatarFile: (file: File) => unknown
  tabBar?: ReactNode
  saveButton?: ReactNode
}

export function ProfileHeader({
  scrollOffset,
  viewTitle,
  displayName,
  avatar,
  isAvatarUploading,
  onSelectNewAvatarFile,
  saveButton,
  tabBar,
}: ProfileHeaderProps) {
  return (
    <StickyViewHeader scrollOffset={scrollOffset} tabBar={tabBar}>
      <StickyViewHeaderMain>
        <ViewHeading
          visual={
            <ProfileAvatar
              avatar={avatar}
              isUploading={isAvatarUploading}
              onSelectNewFile={onSelectNewAvatarFile}
            />
          }
          primaryText={viewTitle}
          secondaryText={displayName}
        />
      </StickyViewHeaderMain>
      <StickyViewHeaderSpacer />
      <StickyViewHeaderExtras>{saveButton}</StickyViewHeaderExtras>
    </StickyViewHeader>
  )
}

interface ProfileAvatarProps {
  avatar: AvatarSubject
  isUploading: boolean
  onSelectNewFile: (file: File) => unknown
}

function ProfileAvatar({
  avatar,
  isUploading,
  onSelectNewFile,
}: ProfileAvatarProps) {
  return (
    <AvatarSelector
      size={byDesign(48, 28)}
      subject={avatar}
      isUploading={isUploading}
      onSelectNewFile={onSelectNewFile}
    />
  )
}
